import React, { useState, FC } from 'react';
import moment, { Moment } from 'moment';
import FeaturedItem from '@common/components/FeaturedItem';
import { DatePicker } from '@features/JourneyPicker';
import Markdown from '@common/components/Markdown';
import { Heading4 } from '@common/components/Typography';
import SectionContainer from '@common/components/SectionContainer';
import { Category, JourneyParams } from 'shared-types/Common';
import { Property } from 'shared-types/Property';
import {
  CategoryViewWrapper,
  StyledPageDescription,
  GridWrapper,
  StyledPageTitleContainer,
} from './SpaEntityCategoryView.styles';

type SpaEntityCategoryViewProps = {
  spaEntityPage: {
    title?: string;
    content?: string;
  };
  property: Property;
  categories: Category[];
  journeyParams: JourneyParams;
  changeJourneyParam: (arg0: string, arg1: Date | Moment) => void;
  categoryRoute: string;
  defaultTitle: string;
};
export const SpaEntityCategoryView: FC<SpaEntityCategoryViewProps> = ({
  categories = [],
  spaEntityPage = {},
  journeyParams,
  changeJourneyParam,
  categoryRoute,
  defaultTitle,
}) => {
  const [date, setDate] = useState(journeyParams.fromDate);
  const { title, content } = spaEntityPage || {};

  const updateJourneyParams = (date) => {
    changeJourneyParam('fromDate', date);
    changeJourneyParam('spaDate', date);
  };

  return (
    <CategoryViewWrapper>
      <SectionContainer>
        <DatePicker
          fromDate={moment(date)}
          handleUpdate={() => {
            updateJourneyParams(date);
          }}
          onDateChange={setDate}
        />
      </SectionContainer>
      <SectionContainer>
        {title ? (
          <StyledPageTitleContainer>
            <Heading4 tag="h1">{title}</Heading4>
          </StyledPageTitleContainer>
        ) : (
          defaultTitle
        )}
        {content && (
          <StyledPageDescription>
            <Markdown text={content} />
          </StyledPageDescription>
        )}
        <GridWrapper>
          {categories.map((category) => (
            <FeaturedItem
              key={category.id}
              title={category.name}
              height={310}
              imageUrl={category.image && category.image.url}
              redirectData={{
                pathname: categoryRoute,
                query: {
                  id: category.id,
                },
              }}
            >
              <h2>{category.name}</h2>
            </FeaturedItem>
          ))}
        </GridWrapper>
      </SectionContainer>
    </CategoryViewWrapper>
  );
};
